import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachDonViNopDanhMucHoSo: {},
  danhSachHoSo: {},
  danhSachHoSoDangThucHien: {},
  danhSachHoSoDuKien: {},
  themHoSoDuKien: {},
  danhSachHienThiCotHoSoCapNhat: [],
  danhSachHienThiCotHoSo: [],
  danhSachYKien: [],
  danhSachLichSu: [],
  hoSoDeMuc: [],
  themHoSo: [],
  danhSachLinhVuc: [],
  danhSachNguoiLapHoSo: [],
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
